module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "body_Praise--Heading3-"
  }, [_vm._v("Praise for Mitzi’s Other"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("Collections")]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“Readers can’t get enough true crime and here comes another winner in Mitzi Szereto’s "), _c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("The Best New True Crime Stories: Partners in Crime")]), _vm._v(". Gathering stories from some of the world’s best writers, Szereto puts together another page-turning collection, telling true crime tales of the wicked, wild, and wonderful. You’ll love this book and the stories of devious partnerships that ended in mayhem an"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("d")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("murder!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold _idGenCharOverride-3"
  }, [_vm._v("Bob Batchelor")]), _vm._v(", cultural historian and author of "), _c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("The Bourbon King: The Life and Crimes of George Remus, Prohibition’s E")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("vil")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  })]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("Genius")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“True crime fans hungering for juicy tales of hot-blooded murder will gobble up the offerings in this irresistibly page-turning"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("co"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("llection.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold _idGenCharOverride-3"
  }, [_vm._v("Harold Schechter")]), _vm._v(", author of "), _c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("Hell’s Princess: The Mystery of Belle Gunness, Butc")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("her of")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  })]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("Men")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“Szereto and her contributors’ dark stories and clean writing styles combine for a gripping read. W"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("onderful!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold _idGenCharOverride-3"
  }, [_vm._v("Liza Rodman")]), _vm._v(", author of "), _c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("The Babysitter: My Summers with a Ser")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("ial")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  })]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("Killer")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“Conjuring the spirits of Truman Capote and Damon Runyon (with the ghost of Patricia Highsmith looking on), the stories in "), _c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("The Best New True Crime Stories:")]), _vm._v(" "), _c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("Well-Mannered Crooks, Rogues & Criminals")]), _vm._v(" thrillingly depict real-life misdeeds throughout history. An Ecuadorian Robin Hood, an art scandal in Paris, new insights into the life and death of a Depression-era bootlegger—what’s not"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" to")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("love?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold CharOverride-1"
  }, [_vm._v("Abbott Kahler")]), _vm._v(", "), _c('span', {
    staticClass: "Italic CharOverride-2"
  }, [_vm._v("New York Times")]), _vm._v(" bestselling author (as Karen Abbott) of "), _c('span', {
    staticClass: "Italic CharOverride-2"
  }, [_vm._v("The Ghosts of")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic CharOverride-2"
  }, [_vm._v(" Eden")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic CharOverride-2"
  })]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic CharOverride-2"
  }, [_vm._v("Park")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“What a fantastic collection of spellbinding true crime stories from around the world! Each one is deeply researched, thoughtful, and fascinating. This anthology is simply good reading for"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" any")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("fan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold _idGenCharOverride-3"
  }, [_vm._v("Kate Winkler Dawson")]), _vm._v(", "), _c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("American Sherlock: Murder, Forensics, and the Birth of Am")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("erican")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  })]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("CSI")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“Here be monsters! This brilliant collection of gruesome small-town misdeeds spanning a century and four continents will have you running for the comfort and safety of the "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("big")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("city.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold _idGenCharOverride-3"
  }, [_vm._v("Peter Houlahan")]), _vm._v(", author of"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("Norco ’80")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“This compelling collection of serial killer stories is more than its beautifully told parts—it adds up to a clear and startling portrait of murder as an addiction and the very human demons that haunt the lives of killers and victi"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ms")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("alike.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold _idGenCharOverride-3"
  }, [_vm._v("Deborah Blum")]), _vm._v(", author of "), _c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("The Poisoner’s Handbook: Murder and the Birth of Forensic Medicine in Jazz-Ag")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("e New")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  })]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("York")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“An engrossing and multi-faceted anthology for a new era of true crime writing. This fascinating collection goes beyond the procedural to raise important questions about how man’s darkest impulses both threaten and consume us—as individuals and as a"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("culture.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold _idGenCharOverride-3"
  }, [_vm._v("Piper Weiss")]), _vm._v(", author of "), _c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("You All Grow Up an")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("d Leave")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  })]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("Me")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32a9e356","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheBestNewTrueCrimeStories-1.vue
// module id = 60
// module chunks = 0